"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TradeTrustTokenErrors__factory = void 0;

var _ethers = require("ethers");

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const _abi = [{
  inputs: [],
  name: "InvalidTokenId",
  type: "error"
}, {
  inputs: [],
  name: "TokenExists",
  type: "error"
}, {
  inputs: [],
  name: "TokenNotSurrendered",
  type: "error"
}, {
  inputs: [],
  name: "TransferFailure",
  type: "error"
}];

class TradeTrustTokenErrors__factory {
  static createInterface() {
    return new _ethers.utils.Interface(_abi);
  }

  static connect(address, signerOrProvider) {
    return new _ethers.Contract(address, _abi, signerOrProvider);
  }

}

exports.TradeTrustTokenErrors__factory = TradeTrustTokenErrors__factory;

_defineProperty(TradeTrustTokenErrors__factory, "abi", _abi);